import { network } from 'services/network';

export const bulkDeleteUserActionsAndRecomendations = (params) => {
    return network.post('api/bo/bulkDeleteUserActionsAndRecomendations', params).then((response) => {
        return response.data;
    });
};
